import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";

const BackButton = ({ onClick, label }) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#ee7225",
        fontSize: "14px",
        fontWeight: 600,
        padding: "4px 0",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ee7225" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
      {label || _t("back", "Back")}
    </button>
  );
};

export default BackButton;
